export default __webpack_public_path__ + "static/media/chartblocks.28102c3d.svg";